import { Route } from '@angular/router';
import { inject } from '@angular/core';
import { RouteIds } from '../../../types';
import { StepResolverService } from '../../../services';
import { PaymentStepComponent } from './payment-step.component';

export const paymentStepRoute: Route = {
  path: RouteIds.payment,
  resolve: { step: () => inject(StepResolverService).resolve(RouteIds.payment) },
  component: PaymentStepComponent,
};
